import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth';
import { Button, ErrorMessage, Field, Input } from '../ui';

export function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-slate-900 p-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 rounded-xl bg-white p-6 shadow-xl">
        <div className="flex items-center gap-2.5">
          <svg viewBox="0 0 32 32" className="size-8" aria-hidden="true">
            <rect width="32" height="32" rx="6" fill="#0f172a" />
            <rect x="6" y="14" width="20" height="11" rx="1.5" fill="#facc15" />
            <circle cx="11" cy="11" r="3" fill="#facc15" />
            <circle cx="21" cy="11" r="3" fill="#facc15" />
          </svg>
          <h1 className="text-xl font-semibold text-slate-900">BrickLoop</h1>
        </div>
        <ErrorMessage error={error} />
        <Field label="Email">
          <Input type="email" autoComplete="username" autoFocus required value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Field label="Password">
          <Input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Button type="submit" className="w-full" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
    </div>
  );
}
